import { Button, Card, Flex, Title, Typography } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { AuthFeatureData } from "~/core";

type RestoreData = ExtractArrayItemType<
  NonNullable<AuthFeatureData>["restore_password"]
>;
export type SuccessRestorePasswordFormProps = {
  data: RestoreData;
  onSubmit: () => void;
};

export const SuccessRestorePasswordForm: FC<
  SuccessRestorePasswordFormProps
> = ({ data, onSubmit }) => {
  return (
    <Card
      variant="secondary"
      minWidth={312}
      minHeight={572}
      maxWidth={440}
      md={{ minHeight: 640, maxWidth: 525 }}
      className="  rounded-2xl md:rounded-lg  "
    >
      <form className=" flex-grow flex flex-col w-full">
        <Flex
          p={{ px: 16, py: 24 }}
          md={{ p: { py: 32, px: 40 } }}
          flexDirection="column"
          className="flex-grow"
        >
          <Title
            as="h2"
            size="small"
            weight="bold"
            p={{ pb: 16 }}
            md={{ p: { pb: 24, pt: 0 }, horizontalAlign: "left" }}
            data-testid="success-restore-password-form-title"
          >
            {data?.form_title}
          </Title>
          <Typography
            size="large"
            className="text-center md:text-start"
            m={{ mb: 12 }}
            data-testid="success-restore-password-form-description"
          >
            {data?.description_text ??
              `An email has been sent to you with instructions for resetting your password`}
          </Typography>
          <Button
            type="submit"
            size="small"
            md={{
              fontSize: "button.desktop.medium",
              p: { py: 16 },
              m: { mt: "auto" },
            }}
            m={{ mt: "auto" }}
            p={{ py: 12 }}
            weight="semibold"
            width="100%"
            maxHeight="none"
            minHeight="none"
            height="fit-content"
            onPress={onSubmit}
            data-testid="success-restore-password-form-button"
          >
            {data?.description_link_text}
          </Button>
        </Flex>
      </form>
    </Card>
  );
};
